// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1InvoiceCreateResponseSchema = z.object({
  creating_invoices: z.number().int().describe("Number of invoices being created"),
  invoice_ids: z.array(z.number().int()).describe("IDs of created invoices"),
  skipped_client_ids: z.array(z.object({
    id: z.number().int(),
    error: z.coerce.string().min(1),
  })).describe("Clients skipped during creation"),
  skipped_project_ids: z.array(z.object({
    id: z.number().int(),
    error: z.coerce.string().min(1),
  })).describe("Projects skipped during creation"),
  error: z.coerce.string().describe("Error message if any").nullish(),
});
